import React from 'react'
import ClusterScopetab from './ClusterScopetab'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import UserMenu from './UserMenu'
import style from './style.module.scss'
import { Tooltip, Affix } from 'antd'
import NotesComp from 'components/common/Notes'
import RouteAccess from 'services/route_access'

const mapStateToProps = ({ menu, settings, user }) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  licenseType: user.licenseType,
})

@withRouter
@connect(mapStateToProps)
class TopBar extends React.Component {
  state = {
    MenuFlag: null,
    active: false,
    showNotes: false,
    licenseType: this.props.licenseType,
    clusterId: null,
    scopeId: null,
    urlParams: {},
  }

  UNSAFE_componentWillMount() {
    this.setState({ MenuFlag: this.props.isMenuCollapsed })

    // this.setSelectedKeys(this.props)
    let url_break = this.props.location.pathname.split('/')
    this.setState(
      {
        clusterId: url_break[1],
        scopeId: url_break[2],
      },
      () => {
        this.makeParams()
      },
    )
  }

  makeParams = () => {
    let url_params = {
      clusterId: this.state.clusterId,
      scopeId: this.state.scopeId,
    }
    this.setState({
      urlParams: url_params,
    })
  }

  onCollapse = (value, type) => {
    const { dispatch, isMenuCollapsed } = this.props
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
    this.setState({ MenuFlag: !isMenuCollapsed })
  }
  toggleClass = () => {
    const currentState = this.state.active
    this.setState({ active: !currentState })
    this.onCollapse()
  }

  closePanel = () => {
    this.setState({ showNotes: false })
  }
  render() {
    let clusterSelected = JSON.parse(localStorage.getItem('userPayload'))
    return (
      <>
        {!window.location.toString().includes('/reportlink/') && (
          <Affix>
            <div className={style.topbar}>
              {/* <div className={style.menuToggIcon}>
              {localStorage.getItem('UserAcc') === 'User - No Access' ||
                localStorage.getItem('UserAcc') === 'Root - No Access' ? null : this.state
                    .MenuFlag ? (
                  <i
                    style={{
                      position: 'relative',

                      fontSize: '1rem',
                      cursor: 'pointer',
                    }}
                    onClick={this.onCollapse}
                    className="fal fa-bars"
                    aria-hidden="true"
                  ></i>
                ) : (
                  <i
                    style={{
                      position: 'relative',

                      fontSize: '1rem',
                      cursor: 'pointer',
                    }}
                    data-fa-transform="rotate-90"
                    onClick={this.onCollapse}
                    className="fal fa-bars fa-rotate-90"
                    aria-hidden="true"
                  ></i>
                )} 
              </div> */}
              <div className="mr-auto">
                {!(
                  window.location.toString().includes('admin/clusters') ||
                  window.location.toString().includes('admin/smtp')
                ) ? (
                  localStorage.getItem('UserAcc') === RouteAccess.USER_NO_ACCESS_ROLES ? null : (
                    <span>
                      Bloo{' '}
                      {typeof clusterSelected.selectedCluster?.productType !== 'undefined'
                        ? clusterSelected.selectedCluster.productType
                        : null}
                      {/* {this.state.licenseType ? this.state.licenseType.toUpperCase() : ''} */}
                    </span>
                  )
                ) : null}
                {/* <span
            style={{
              color: '#adc6ff',
              background: '#232135',
              border: '1px solid #2f54eb',
              fontSize: '0.6rem',
              padding: '0px 3px',
              borderRadius: '2px',
              marginLeft: '8px',
            }}
            className={'consoleTagStyle'}
          >
            beta
          </span> */}
                {/* <Breadcrumbs style={{ padding: '0px' }} /> */}
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {!(
                  window.location.toString().includes('admin/clusters') ||
                  window.location.toString().includes('admin/user') ||
                  window.location.toString().includes('admin/smtp') ||
                  window.location.toString().includes('admin/tenants') ||
                  window.location.toString().includes('admin/organizations')
                ) && (
                  <div
                    className="d-none d-md-block"
                    style={{
                      marginRight:
                        !RouteAccess.USER_NO_ACCESS_ROLES.includes(
                          localStorage.getItem('UserAcc'),
                        ) &&
                        !RouteAccess.ROOT_NO_ACCESS_ROLES.includes(
                          localStorage.getItem('UserAcc'),
                        ) &&
                        !RouteAccess.ORG_ADMIN_NO_ACCESS_ROLES.includes(
                          localStorage.getItem('UserAcc'),
                        ) &&
                        !RouteAccess.VIEWER_ROLES.includes(localStorage.getItem('UserAcc'))
                          ? '0'
                          : '-10px',
                    }}
                  >
                    <ClusterScopetab />
                  </div>
                )}

                {!(
                  window.location.toString().includes('admin/clusters') ||
                  window.location.toString().includes('admin/user') ||
                  window.location.toString().includes('admin/components') ||
                  window.location.toString().includes('admin/smtp') ||
                  window.location.toString().includes('admin/switchboard')
                ) && (
                  <div style={{ padding: '8px 0px 10px 8px' }} className="">
                    {!RouteAccess.USER_NO_ACCESS_ROLES.includes(localStorage.getItem('UserAcc')) &&
                    !RouteAccess.ROOT_NO_ACCESS_ROLES.includes(localStorage.getItem('UserAcc')) &&
                    !RouteAccess.ORG_ADMIN_NO_ACCESS_ROLES.includes(
                      localStorage.getItem('UserAcc'),
                    ) &&
                    !RouteAccess.VIEWER_ROLES.includes(localStorage.getItem('UserAcc')) ? (
                      <>
                        <Tooltip title="Notes">
                          <span
                            className={style.HoverIcon}
                            onClick={() => {
                              this.setState({ showNotes: true })
                            }}
                          >
                            <i className="fal fa-file-alt"></i>
                          </span>
                        </Tooltip>
                      </>
                    ) : null}
                  </div>
                )}
                {/* {this.state.showChatIcon && ( */}
                {/* <div style={{ padding: '8px 1px 10px 8px' }} className={this.state.toggleChat ? 'chatHandler clicked' : 'chatHandler'}>
                <Tooltip title={this.state.toggleChat ? 'Close Chat Support' : 'Open Chat Support'}>
                  <span
                    className={style.HoverIcon}
                    onClick={(e) => {
                      this.setState({ toggleChat: !this.state.toggleChat }, () => {
                        this.chatHandle(this.state.toggleChat)
                      })
                    }}
                  >
                    <i className={this.state.toggleChat ? 'fal fa-comment-alt-slash' : 'fal fa-comments-alt'}></i>
                  </span>
                </Tooltip>
              </div> */}
                {/* )} */}
                <div style={{ padding: '8px 1px 10px 8px' }} className="">
                  <UserMenu />
                </div>
                {this.state.showNotes ? (
                  <NotesComp
                    visible={this.state.showNotes}
                    setPanelVisibility={this.closePanel}
                    type={'drawer'}
                    urlData={this.state.urlParams}
                  />
                ) : null}
              </div>
            </div>
          </Affix>
        )}{' '}
      </>
    )
  }
}

export default withRouter(TopBar)
